module.exports = __webpack_public_path__ + "static/media/hot-noodles-img.d10cf130.jpg";